import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var checkClickTargetIsAccordion = function checkClickTargetIsAccordion(n, e) {
  var parent = e.target.parentElement;

  while (parent && n > 0) {
    if (parent.dataset.target === 'accordion') {
      return true;
    } else {
      parent = parent.parentElement;
      n--;
    }
  }

  return false;
};

var checkClickTargetIsLink = function checkClickTargetIsLink(e) {
  if (e.target.nodeName.toLowerCase() === 'a') {
    return true;
  }
};

var linkWrapper = function linkWrapper(options) {
  var link = options.link,
      children = options.children,
      headerImage = options.headerImage,
      onRowClick = options.onRowClick;

  var handleClick = function handleClick(e) {
    if (checkClickTargetIsAccordion(10, e) && !checkClickTargetIsLink(e)) {
      e.preventDefault();
    }

    if (onRowClick) onRowClick();
    return e;
  };

  return _jsx("a", {
    sx: {
      textDecoration: 'none',
      color: 'inherit',
      variant: 'compounds.product-table.row.linkWrapper',
      paddingX: ['sm', 'md'],
      paddingY: 'md',
      paddingTop: headerImage && ['sm', 'md'],
      display: 'block'
    },
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: children
  });
};

var RowWrapper = function RowWrapper(_ref) {
  var link = _ref.link,
      children = _ref.children,
      headerImage = _ref.headerImage,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      className = _ref.className,
      onRowClick = _ref.onRowClick;
  return link ? linkWrapper({
    link: link,
    children: children,
    headerImage: headerImage,
    onRowClick: onRowClick
  }) : _jsx("div", {
    sx: _objectSpread({
      paddingY: 'md',
      paddingTop: headerImage && ['sm', 'md']
    }, sx),
    className: className,
    children: children
  });
};

export default RowWrapper;
//# sourceMappingURL=row-wrapper.js.map